<style>
.form-control {
    border-radius: 0;
    height: 50px !important;
    font-size: 16pt;
}

#Container .card {
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}

#Container .card-img-top {
    border-radius: 0;
}

#Container .card-body a {
    color: #0c2340;
}

#Container .card-body a:hover {
    color: #e87722;
}
</style>

<template>
    <div class="container" id="directory">
        <h1 class="p-5 text-center">News Articles</h1>

        <form class="controls" id="Filters">
            <div class="form-row">
                <div class="form-group col-md">
                    <input class="form-control" placeholder="Search..." onkeydown="return (event.keyCode!=13);"
                        v-model="searchTerm" v-on:keyup="changeSearchBox" />

                </div>

                <category-listing-block v-on:change:categoryfilter="changeCategoryFilter" v-bind:initial="category"
                    v-bind:category-list="categoryList" />

            </div>
        </form>

        <div class="row">
            <div class="col">
                <nav aria-label="Page navigation">
                    <ul class="pagination justify-content-center">
                        <!-- Jump to beginning -->
                        <li class="page-item"><button class="page-link" aria-label="First Page" v-on:click="firstPage"><i
                                    class="fas fa-step-backward"></i></button></li>
                        <!-- Decrement 1 -->
                        <li class="page-item"><button class="page-link" aria-label="Back one page"
                                v-on:click="previousPage"><i class="fas fa-backward"></i></button></li>
                        <!-- Enter field / Placeholder shows current page / programmatically set max to totalPages-->
                        <li class="page-item px-1">
                        <label for="page-top" class="sr-only">Page Number</label>
                            <input type="number" class="form-control px-1" v-model.number="currentPage"
                                v-on:change="changePageModel" min="1" v-bind:max="articleList.totalPages" id="page-top">
                        </li>
                        <!-- Clickable and set to max pages -->
                        <li class="page-item"><button class="page-link px-1" disabled>of {{ articleList.totalPages }}</button>
                        </li>
                        <!-- Increment 1 -->
                        <li class="page-item"><button class="page-link" aria-label="Forward one page"
                                v-on:click="nextPage"><i class="fas fa-forward"></i></button></li>
                        <!-- Jump to end -->
                        <li class="page-item"><button class="page-link" aria-label="Last page" v-on:click="lastPage"><i
                                    class="fas fa-step-forward"></i></button></li>
                        <li class="page-item"><button class="page-link" aria-label="Reset Filters"
                                v-on:click="clearFilters"><i class="fas fa-undo"></i></button></li>
                    </ul>
                </nav>
            </div>
        </div>

        <section id="4coltest">
            <div class="container" id="Container">

                <div class="row row-cols-1 row-cols-md-3 row-cols-lg-4 list" id="people">
                    <article-listing-block v-for="article in articleList.results" v-bind:article="article"
                        v-bind:key="article.id" />
                </div>
            </div>
        </section>

        <div class="row">
            <div class="col">
                <nav aria-label="Page navigation">
                    <ul class="pagination justify-content-center">
                        <!-- Jump to beginning -->
                        <li class="page-item"><button class="page-link" aria-label="First Page" v-on:click="firstPage"><i
                                    class="fas fa-step-backward"></i></button></li>
                        <!-- Decrement 1 -->
                        <li class="page-item"><button class="page-link" aria-label="Back one page"
                                v-on:click="previousPage"><i class="fas fa-backward"></i></button></li>
                        <!-- Enter field / Placeholder shows current page / programmatically set max to totalPages-->
                        <li class="page-item px-1">
                            <label for="page-bottom" class="sr-only">Page Number</label>
                            <input type="number" class="form-control px-1" v-model.number="currentPage"
                                v-on:change="changePageModel" min="1" v-bind:max="articleList.totalPages" id="page-bottom">
                        </li>
                        <!-- Clickable and set to max pages -->
                        <li class="page-item"><button class="page-link px-1" disabled>of {{ articleList.totalPages }}</button>
                        </li>
                        <!-- Increment 1 -->
                        <li class="page-item"><button class="page-link" aria-label="Forward one page"
                                v-on:click="nextPage"><i class="fas fa-forward"></i></button></li>
                        <!-- Jump to end -->
                        <li class="page-item"><button class="page-link" aria-label="Last page" v-on:click="lastPage"><i
                                    class="fas fa-step-forward"></i></button></li>
                        <li class="page-item"><button class="page-link" aria-label="Reset Filters"
                                v-on:click="clearFilters"><i class="fas fa-undo"></i></button></li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>


<script>
import ArticleListingBlock from './ArticleListingBlock.vue';
import CategoryListingBlock from './CategoryListingBlock.vue';
export default {
    name: 'ArticleListing',
    props: ['articles'],
    components: {
        'article-listing-block': ArticleListingBlock,
        'category-listing-block': CategoryListingBlock
    },
    data: function () {
        return {
            categoryList: {},
            articleList: {},
            searchTerm: '',
            currentPage: 1,
            category: ''
        };
    },
    methods: {
        //API Calls to get data
        getCategory: function () {
            return this.axios.get('/umbraco/api/NewsArticleListing/GetCategoryList');
        },

        getArticleList: function (page, category, searchTerm) {
            return this.axios.get('/umbraco/api/NewsArticleListing/GetArticleList', {
                params: {
                    page: page,
                    category: category,
                    searchTerm: searchTerm
                }
            });
        },
        previousPage: function () {
            if (this.currentPage <= 1) {
                this.currentPage = 1;
            } else {
                this.currentPage -= 1;
            }
            this.refreshData();
        },
        nextPage: function () {
            if (this.currentPage < this.articleList.totalPages) {
                this.currentPage += 1;
            } else {
                this.currentpage = this.articleList.totalPages;
            }
            this.refreshData();
        },
        firstPage: function () {
            this.currentPage = 1;
            this.refreshData();
        },
        lastPage: function () {
            this.currentPage = this.articleList.totalPages;
            this.refreshData();
        },
        changePageModel: function () {
            if (this.currentPage > this.articleList.totalPages) this.currentPage = this.articleList.totalPages;
            if (this.currentPage < 1) this.currentPage = 1;
            this.refreshData();
        },
        gotoPage: function (page) {
            this.currentPage = page;
            this.refreshData();
        },
        changeCategoryFilter: function (category) {
            // console.log(category);
            this.category = category;
            this.currentPage = 1;
            this.refreshData();
        },
        changeSearchBox: function () {
            this.currentPage = 1;
            this.refreshData();
        },
        clearFilters: function () {
            this.category = '';
            this.searchTerm = '';
            this.currentPage = 1;
            this.refreshData();
        },
        writeUrl: function () {
            // console.log('writeurl was touched');
            var queryObj = {};

            if (this.currentPage != 1) {
                queryObj.page = this.currentPage;
            }

            if (this.category) {
                queryObj.category = this.category;
            }

            if (this.searchTerm) {
                queryObj.searchTerm = this.searchTerm;
            }
            // console.log(queryObj);
            this.$router.push({
                query: queryObj
            });
        },
        refreshData(skipUrlUpdate) {
            // console.log('refresh data was touched');
            if (!skipUrlUpdate) {
                this.writeUrl();
            }
            console.log('[refreshdata] refreshing data with params:', this.currentPage, this.category, this.searchTerm);
            this.getArticleList(this.currentPage, this.category, this.searchTerm).then(response => (this.articleList = response.data));
        }
    },
    watch: {

        '$route': {
            handler(newRoute, oldRoute) {
                console.log('route changed', this.$route.query);
                console.log('current category', this.category);

                console.log('page:' + this.$route.query.page);
                console.log('category:' + this.$route.query.category);
                console.log('new route',newRoute);
                console.log('old route',oldRoute);

                if(!newRoute.query.page) {
                    this.currentPage = 1;
                 }

                if (!!newRoute.query.page && newRoute.query.page !== this.currentPage) {
                    this.currentPage = parseInt(newRoute.query.page);
                }

                if(!this.$route.query.category){
                    this.category = "";
                }

                if (!!this.$route.query.category && this.$route.query.category !== this.category.name) {
                    this.category = this.$route.query.category;
                    
                    this.getCategory().then(response => {
                        console.log('mounted got categories', response.data);
                        this.categoryList = response.data;

                        console.log('finding cat', this.categoryList.results);

                        const foundCat = this.categoryList.results.find(c => c.categoryName.localeCompare(this.$route.query.category, 'en', { sensitivity: 'base' }) == 0);
                        console.log('found category', foundCat);

                        //this.category = foundCat;
                    });

                }

                if (!!this.$route.query.searchTerm && this.$route.query.searchTerm !== this.searchTerm) {
                    this.searchTerm = this.$route.query.searchTerm;
                }

                // if (this.$route.query.page) {
                //     this.currentPage = 1;          
                // }

                // if(this.$route.query.category) {
                //     this.category = '';
                // }


                // console.log('page:' + this.$route.query.page);
                // console.log('category:' + this.$route.query.category);
                // console.log('route:' + this.$route);
                this.refreshData(true);
            },
            immediate: true
        }
    },
    mounted: function () {
        if (this.$route.query.page) {
                // console.log('new page found', this.$route.query.page);
                this.currentPage = this.$route.query.page;
                // console.log('new page set', this.currentPage);
            }

            if (this.$route.query.category) {
                this.category = this.$route.query.category;
            }

        this.getCategory().then(response => { 
            console.log('mounted got categories', response.data); 
            this.categoryList = response.data; 

            //if (this.$route.query.category) {
                console.log('[art-list:mounted] finding category from url', this.$route.query.category, this.categoryList);        
                const foundCat = this.categoryList.results.find(c => c.categoryName.localeCompare(this.$route.query.category, 'en', { sensitivity: 'base' }) == 0);
                console.log('[art-list:mounted] found category', foundCat.categoryName, foundCat);
                //this.category = foundCat.categoryName;
            //}
        }).then(()=>{
            
        });
        this.getArticleList(this.currentPage, this.category, this.searchTerm).then(response => { console.log('mounted got articles', response.data); this.articleList = response.data; });
        // console.log('the query', this.$route);
    }
}
</script>